<template>
    <div class="progress-bar">
        <div class="progress-bar-slider d-flex align-center px-12">
            <v-slider v-model="current" color="secondary" track-size="10" readonly hide-details :max="100"/>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        steps: {
            type: Number,
            required: true
        },
        currentStep: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            current: 0,
            newCurrent: 0
        }
    },

    watch: {
        currentStep: {
            immediate: true,
            handler() {
                this.newCurrent = 100 / this.steps * this.currentStep;
                this.updateCurrent();
            }
        }
    },
    methods: {
        async updateCurrent() {
            while (this.current > this.newCurrent) {
                this.current -= 1;
                await new Promise(resolve => setTimeout(resolve, 10));
            }

            while (this.current < this.newCurrent) {
                this.current += 1;
                await new Promise(resolve => setTimeout(resolve, 10));
            }

            if (this.current >= 100) {
                this.current = 100;
            }
        }
    }
}
</script>